import { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  LabelList,
  ResponsiveContainer,
} from 'recharts';
import axios from 'axios';
import { Loader } from '../';

const ChartNP = ({ state, code, height = 220 }) => {
  const [info, setInfo] = useState();
  const [done, setDone] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchChart = async () => {
      try {
        const lang = localStorage.getItem('lang') || 'zh_CN';
        const res = await axios.get(`public-api/chartNP?state=${state}&code=${code}&lang=${lang}`);
        if (!cancelled) {
          setInfo(res.data || []);
          setDone(true);
        }
      } catch {
        if (!cancelled) setDone(true);
      }
    };
    fetchChart();
    return () => {
      cancelled = true;
    };
  }, [code, state]);

  if (!done) return <Loader inline />;
  if (!info || !info.length) return null;

  const max = info[0]?.total || undefined;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        layout="vertical"
        data={info}
        margin={{ top: 8, right: 32, left: 8, bottom: 8 }}
        barCategoryGap="20%"
      >
        <XAxis
          type="number"
          domain={[0, max || 'auto']}
          tick={{ fontSize: 12, fill: '#666' }}
          axisLine={{ stroke: '#ddd' }}
          tickLine={false}
        />
        <YAxis
          type="category"
          dataKey="name"
          tick={{ fontSize: 13, fill: '#333' }}
          width={84}
          axisLine={{ stroke: '#ddd' }}
          tickLine={false}
        />
        <Bar
          dataKey="value"
          background={{ fill: '#eee', radius: 2 }}
          radius={[2, 2, 2, 2]}
          isAnimationActive={false}
        >
          {info.map((d, i) => (
            <Cell key={i} fill={d.colors} />
          ))}
          <LabelList
            dataKey="value"
            position="right"
            style={{ fill: '#666', fontSize: 13, fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ChartNP;
